import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    simProviderDeleteRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteSimProvider = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        current,
        result
    } = useSelector(state => state.deleteSimProviderRedux);

    const closeModal = () => {
        dispatch(clearRedux("SIM_PROVIDER_DELETE"))
    }

    const deleteSimProvider = () => {
        dispatch(simProviderDeleteRequest(current?.id))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['sim_provider_delete_success_message'],
                    messages['sim_provider_delete_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
                closeModal();
            } else {
                let message = messages['sim_provider_delete_error_message']
                if(result && result?.error && result?.error?.includes("in use")){
                    message = messages['sim_provider_delete_package_in_use']
                }
                NotificationManager.error(
                    message,
                    messages['sim_provider_delete_title'],
                    3000
                );
                dispatch(clearRedux("SIM_PROVIDER_DELETE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['sim_provider_delete_title']} (${current?.name})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <span>{messages['sim_provider_delete_confirm_message']}</span>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => deleteSimProvider()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteSimProvider;